export const API_URLS = {
	GET_PODCASTS: "/podcastintegration",
	UPDATE_DELETE_PODCAST_RSS: (integrationId: string): string => `${API_URLS.GET_PODCASTS}/${integrationId}/rsslinks`
};
